import React from 'react'
import { MetricCard, type MetricCardProps } from './metric-card'

/**
 * Compatibility facade for older screens. All KPI rendering is provided by
 * MetricCard so legacy report pages cannot drift into a second visual system.
 */
interface StatsCardProps extends Omit<MetricCardProps, 'size' | 'emphasis'> {
  size?: 'default' | 'sm'
}

export function StatsCard({ size = 'default', kpiTier = 'primary', ...props }: StatsCardProps) {
  return (
    <MetricCard
      {...props}
      size={size === 'sm' ? 'compact' : 'default'}
      emphasis={kpiTier === 'primary' ? 'primary' : 'standard'}
      kpiTier={kpiTier}
    />
  )
}
